import { Injectable } from '@angular/core';
import {
  NavItem,
  NavItemLinks,
  SecondaryNavItem
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  checkStringValueNull,
  getPrimaryNavigationId,
  getSecondaryNavigationId,
  HeaderFooterMachCore
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  PrimaryId,
  SecondaryId
} from '../../constants/navigation-links/navigation-linkts-constants';

@Injectable({
  providedIn: 'root'
})
export class NavigationLinksAdapterService {
  getContent(content: HeaderFooterMachCore): NavItemLinks {
    return {
      primary: this.getPrimaryDetails(content),
      secondary: this.getSecondaryDetails(content)
    };
  }

  getPrimaryDetails(content: HeaderFooterMachCore): NavItem[] {
    return PrimaryId.map((id) => this.getNavigationDetails(content, id));
  }

  getNavigationDetails(
    content: HeaderFooterMachCore,
    navigationId: string
  ): NavItem {
    const navItem = getPrimaryNavigationId(content, navigationId);

    return {
      id: checkStringValueNull(navItem?.id),
      label: this.transformLabel(checkStringValueNull(navItem?.label)),
      searchUrl: checkStringValueNull(navItem?.searchUrl),
      details: {
        legacyAppUrl: checkStringValueNull(navItem?.legacyAppUrl)
      },
      redirectMobile: this.shouldRedirectMobile(navItem?.redirectMobile),
      redirectMobileUrl: checkStringValueNull(navItem?.redirectMobileUrl)
    };
  }

  shouldRedirectMobile(redirectMobile?: string): boolean {
    return redirectMobile === 'false' || redirectMobile === undefined
      ? false
      : true;
  }

  transformLabel(label: string): string {
    if (!label) return label;
    return label
      .toLowerCase()
      .replace(/^\w|\s\w/g, (char) => char.toUpperCase());
  }

  getSecondaryDetails(content: HeaderFooterMachCore): SecondaryNavItem[] {
    return SecondaryId.map((value) => {
      const secondary = getSecondaryNavigationId(content, value);
      return {
        id: checkStringValueNull(secondary?.id),
        label: checkStringValueNull(secondary?.label)
      };
    });
  }
}
